import { useForm } from "@tanstack/react-form";
import dayjs from "dayjs";
import type { DailyLogFormValues } from "./schema";

export const DAILY_LOG_DEFAULT_VALUES: DailyLogFormValues = {
  description: "",
  location: "",
  date: dayjs().format("YYYY-MM-DD"),
  weather: "",
  temperature: 0,
  precipitation: 0,
  processRate: 0,
  tags: [],
  workforce_contractors: [],
  equipment_contractors: [],
  image_urls: [],
};

interface UseDailyLogFormOptions {
  onSubmit: (values: DailyLogFormValues) => void;
  defaultValues?: Partial<DailyLogFormValues>;
}

export function useDailyLogForm({ onSubmit, defaultValues }: UseDailyLogFormOptions) {
  return useForm({
    defaultValues: { ...DAILY_LOG_DEFAULT_VALUES, ...defaultValues },
    onSubmit: ({ value }) => onSubmit(value),
  });
}

export type DailyLogForm = ReturnType<typeof useDailyLogForm>;
